var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { STACK_ALIGN, STACK_DIRECTION, STACK_DISTRIBUTION, STACK_GAP, StackView } from "../StackView";
import { SPACE_FILL, INDENT } from "../View";
import { Text, TEXT_VIEW, TEXT_WEIGHT } from "../Text";
import { LinkButton } from "../controls/LinkButton";
import { FormGroupContextProvider } from "../FormGroupContext";
import { SIZE_M, SIZE_XS, SIZE_XXS, SPACING_M, SPACING_S, FONT_LINE_HEIGHT_L } from "../helpers";
import { ArrowDownIcon, ArrowRightIcon } from "../ArrowIcon";
import { Spacer } from "../layouts";
import { ClearIcon } from './icons/ClearIcon';
var DEFAULT_TEXTS = {
    clear: 'Clear'
};
var arrowIconColor = function (_a) {
    var hasFilters = _a.hasFilters;
    return !hasFilters && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fill: ", ";\n    "], ["\n        fill: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.colorTextMain;
    });
};
var StyledArrowDownIcon = styled(ArrowDownIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n"], ["\n    ", ";\n"])), arrowIconColor);
var StyledArrowRightIcon = styled(ArrowRightIcon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n"], ["\n    ", ";\n"])), arrowIconColor);
var WrapperIconCSS = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    width: ", ";\n    height: ", ";\n"], ["\n    display: flex;\n    width: ", ";\n    height: ", ";\n"])), SIZE_M, SIZE_M);
var WrapperArrow = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    min-width: ", ";\n    ", "\n"], ["\n    min-width: ", ";\n    ", "\n"])), SIZE_M, WrapperIconCSS);
var Title = styled(Text)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-left: ", ";\n    line-height: ", ";\n    cursor: default;\n"], ["\n    padding-left: ", ";\n    line-height: ", ";\n    cursor: default;\n"])), SIZE_XXS, FONT_LINE_HEIGHT_L);
var WrapperClearIcon = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-right: ", ";\n    ", "\n"], ["\n    margin-right: ", ";\n    ", "\n"])), SPACING_S, WrapperIconCSS);
var Wrapper = styled(StackView)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    padding: 0 ", ";\n    position: relative;\n\n    ", "\n"], ["\n    padding: 0 ", ";\n    position: relative;\n\n    ",
    "\n"])), SPACING_M, function (_a) {
    var hasBorder = _a.hasBorder, theme = _a.theme;
    return hasBorder && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n            &::before {\n                content: '';\n                position: absolute;\n                left: 0;\n                top: 0;\n                height: 100%;\n                border-left: ", " solid ", ";\n            }\n        "], ["\n            &::before {\n                content: '';\n                position: absolute;\n                left: 0;\n                top: 0;\n                height: 100%;\n                border-left: ", " solid ", ";\n            }\n        "])), SIZE_XS, theme.colorStripeAccent);
});
export var SideFilterItemGroup = function (_a) {
    var title = _a.title, _b = _a.hasFilters, hasFilters = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.opened, externalOpened = _d === void 0 ? true : _d, contentRenderer = _a.contentRenderer, texts = _a.texts, onClearClick = _a.onClearClick, rest = __rest(_a, ["title", "hasFilters", "disabled", "opened", "contentRenderer", "texts", "onClearClick"]);
    var _e = useState(externalOpened), opened = _e[0], setOpened = _e[1];
    useEffect(function () {
        if (externalOpened) {
            setOpened(externalOpened);
        }
    }, [externalOpened]);
    var uiTexts = __assign(__assign({}, DEFAULT_TEXTS), texts);
    var handleClickTitle = function () {
        setOpened(!opened);
    };
    return (React.createElement(Wrapper, { spaceFill: SPACE_FILL.all, direction: STACK_DIRECTION.column, gap: STACK_GAP.s, hasBorder: hasFilters, "data-selector-id": rest['data-selector-id'] },
        React.createElement(StackView, { align: STACK_ALIGN.center, direction: STACK_DIRECTION.row, distribution: STACK_DISTRIBUTION.between },
            React.createElement(WrapperArrow, { onClick: handleClickTitle }, opened ? (React.createElement(StyledArrowDownIcon, { hasFilters: hasFilters })) : (React.createElement(StyledArrowRightIcon, { hasFilters: hasFilters }))),
            React.createElement(Title, { weight: TEXT_WEIGHT.bold, view: hasFilters ? TEXT_VIEW.link : TEXT_VIEW.primary, truncate: true, onClick: handleClickTitle, "data-selector-id": rest['data-selector-id'] ? "title-" + rest['data-selector-id'] : undefined }, title),
            React.createElement(Spacer, null),
            hasFilters && (React.createElement(LinkButton, { onClick: onClearClick, disabled: disabled, compact: true },
                React.createElement(StackView, { indentLeft: INDENT.m, align: STACK_ALIGN.center },
                    React.createElement(WrapperClearIcon, null,
                        React.createElement(ClearIcon, { isDisabled: disabled })),
                    uiTexts.clear)))),
        opened && (React.createElement(FormGroupContextProvider, { value: { disabled: disabled } }, contentRenderer({ disabled: disabled })))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=SideFilterItemGroup.js.map